import { Alert, AlertIcon } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { SocketStatus } from "../../helper/socketClient";

const SocketStatusBanner: React.FC<{ status: SocketStatus }> = ({ status }) => {
  const { t } = useTranslation();

  if (status === "ok") return null;

  return (
    <Alert
      role="alert"
      status={status === "expired" ? "error" : "warning"}
      mb={2}
      borderRadius="md"
    >
      <AlertIcon />
      {t(
        status === "expired"
          ? "missingWording.socketSessionExpired"
          : "missingWording.socketDisconnected",
      )}
    </Alert>
  );
};

export default SocketStatusBanner;
